import script from "./employee-list-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-list-modal.vue?vue&type=script&setup=true&lang=js"

import "./employee-list-modal.vue?vue&type=style&index=0&id=bfe88268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfe88268"]])

export default __exports__